/**
 * Given a list of property specification objects, get a map associating
 * key names with specification objects.
 */
export function getPropertiesMap(properties) {
    const map = {};
    for (const property of properties) {
        map[property.key] = property;
    }
    return map;
}
//# sourceMappingURL=commonProperties.js.map